import React from 'react';
import ReactDOM from 'react-dom/client';
import 'styles/index.css';
import Rentman from 'components/Rentman';
import { AuthProvider } from 'auth/AuthContext';
import AuthGate from 'auth/AuthGate';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <AuthProvider>
      <AuthGate>
        <Rentman />
      </AuthGate>
    </AuthProvider>
  // </React  .StrictMode>
);
